<template>
	<TeamingDialog
		:class-name="classes"
		:show-dialog="showDialog"
	>
		<template #heading>
			<span class="assessment-dialog__heading">{{ $t( "common.AssessmentDialog_title" ) }}</span>
		</template>

		<section class="assessment-dialog__body">
			<iframe
				:class="iframeClasses"
				ref="assessmentFrame"
				src="/t2/assessment.html"
				frameBorder="0"
				scrolling="no">
			</iframe>
		</section>
	</TeamingDialog>
</template>

<script>
import TeamingDialog from "../TeamingDialog";

export default {
	name: "AssessmentDialog",
	components: {
		TeamingDialog,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		showDialog: {
			Boolean,
			required: true,
		},
	},
	computed: {
		classes() {
			return `assessment-dialog ${ this.className }`.trim();
		},
		iframeClasses() {
			return "assessment-dialog__iframe";
		},
	},
};
</script>

<style lang="scss">
.assessment-dialog {
	@include for-size('xs') {
		width: 100vw;
	}
	@include for-size('sm') {
		width: 85vw;
	}
	@include for-size('md') {
		width: 75vw;
	}
	@include for-size('lg') {
		width: 55vw;
	}
}
</style>

<style lang="scss" scoped>
.assessment-dialog__heading {
	color: $assessment-dialog-heading-color;
}

.assessment-dialog__body {
	width: 100%;
}

.assessment-dialog__iframe {
	border: 0;
	position: relative;
	width: 100%;
	height: 26rem;

	@include for-size('sm') {
		height: 25rem;
	}
}
</style>
